module.exports = {
    trial: {
        backgroundLimit: 1,
        importLimit: 3,
        generateAiLimit: 3,
    },
    board: {
        name: 'board',
        paymentMode: 'payment',
        backgroundLimit: 15,
        importLimit: 50,
        generateAiLimit: 50,
        stripePriceId: "price_1NmIRIGxaKbAyNHesF0XiIEv"
    },
    personal: {
        name: 'Personal',
        backgroundLimit: 100,
        importLimit: 200,
        generateAiLimit: 100,
        stripePriceId: "price_1OyyDrGxaKbAyNHe4xOeqj1b",
        stripePriceIdYear: "price_1Qibq8GxaKbAyNHeL0BHKwB9",
        stripePriceIdLifetime: "price_1SX2qwGxaKbAyNHeXaMf3q7J",
        price: 29,
        yearPrice: 180,
        lifetimePrice: 149
    },
    business: {
        name: 'Business',
        backgroundLimit: 200,
        importLimit: 400,
        generateAiLimit: 200,
        stripePriceId: "price_1QnKBCGxaKbAyNHeYZz5mfQo",
        stripePriceIdYear: "price_1QnKCtGxaKbAyNHesz7InMIJ",
        price: 49,
        yearPrice: 468
    },
    premium: {
        name: 'Premium',
        backgroundLimit: 400,
        importLimit: 800,
        generateAiLimit: 400,
        stripePriceId: "price_1QnKE7GxaKbAyNHeGqZ596ei",
        stripePriceIdYear: "price_1QnKEmGxaKbAyNHeX6qJfZWP",
        price: 89,
        yearPrice: 900
    },
}